module.exports = __webpack_public_path__ + "static/media/prof.be45e812.png";